// extracted by mini-css-extract-plugin
module.exports = {"root":"_ab5f6ea","winnerItem":"_fcec8c4","winnerDetails":"_7ea8275","winnerUsername":"_49040f8","winnerAward":"_21deeb4"};